import { Injectable } from '@angular/core';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs'; // вернуть map из 'rxjs'
import { ConfigService } from '../config.service';
import {
  OrderByIdResultDto,
  OrdersResultDto,
  SignEndOfDayRequest,
  SignExpeditorNoteResultDto
} from '../../dto/order.dto';
import { Status } from '../../dto/status.enum';
import { ResponseDto } from '../../dto/shared.dto';
import { HttpRetryableService } from '../http-retryable.service';

@Injectable({ providedIn: 'root' })
export class OrderApiService {
  private readonly baseUrl: string;

  constructor(
    private http: HttpRetryableService,
    private config: ConfigService
  ) {
    this.baseUrl = this.config.baseRestURL;
  }

  getOrdersList(
    limit: number,
    offset: number,
    loadingIds: string,
    status?: Status[],
    requestTrackId?: string
  ): Observable<OrdersResultDto> {
    const params = new HttpParams()
      .set('status', status?.join(',') || '')
      .set('limit', limit.toString())
      .set('offset', offset.toString())
      .set('loadingIds', loadingIds);

    return this.http.get<OrdersResultDto>(
      `${this.baseUrl}forwarding/request/list`,
      { params, requestTrackId }
    );
  }

  getOrderById(id: number): Observable<OrderByIdResultDto | null> {
    return this.http
      .get<OrderByIdResultDto>(`${this.baseUrl}forwarding/request/${id}`, {
        observe: 'response'
      })
      .pipe(
        map((resp: HttpResponse<OrderByIdResultDto>) =>
          resp.status === 204 ? null : resp.body
        )
      );
  }

  acceptOrder(data: {
    requestId: number;
  }): Observable<ResponseDto> {
    return this.http.post<ResponseDto>(
      `${this.baseUrl}forwarding/request/accept`,
      data
    );
  }

  declineOrder(data: { requestId: number }): Observable<ResponseDto> {
    return this.http.post<ResponseDto>(
      `${this.baseUrl}forwarding/request/decline`,
      data
    );
  }

  finishForwarding(id: number): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(
      `${this.baseUrl}forwarding/request/${id}/finish`,
      {}
    );
  }

  /**
   * Вариант завершения заявки для очереди синхронизации. Повтор уже завершённой заявки сервер
   * отвечает 208 (ALREADY_REPORTED) со строковым телом (не конвертом Response), поэтому читаем ответ
   * как текст и наблюдаем статус: разбор JSON на строковом теле упал бы. Любой 2xx (в т.ч. 208)
   * означает, что заявка завершена. Приведение типов локальное: базовый post отдаёт тело как JSON,
   * а нам нужен сырой ответ с текстовым телом.
   */
  finishForwardingForSync(id: number): Observable<HttpResponse<string>> {
    return this.http.post<string>(
      `${this.baseUrl}forwarding/request/${id}/finish`,
      {},
      { observe: 'response', responseType: 'text' } as unknown as {
        observe: 'response';
      }
    ) as unknown as Observable<HttpResponse<string>>;
  }

  signExpeditorNote(
    payload: SignEndOfDayRequest,
    bargainId: number
  ): Observable<SignExpeditorNoteResultDto> {
    return this.http.post<SignExpeditorNoteResultDto>(
      `${this.baseUrl}order/bargain/${bargainId}/forwarder_receipt/sign`,
      payload
    );
  }
}
